function initReDocEnhancements() {
  // Add custom styles for tabs

  // Language mapping for better display names and badges
  const languageMap = {
    js: { name: 'Node.js', badge: 'nodejs' },
    javascript: { name: 'JavaScript', badge: 'javascript' },
    php: { name: 'PHP', badge: 'php' },
    csharp: { name: 'C#', badge: 'csharp' },
    cs: { name: 'C#', badge: 'csharp' },
    python: { name: 'Python', badge: 'python' },
    py: { name: 'Python', badge: 'python' },
    bash: { name: 'Bash', badge: 'bash' },
    sh: { name: 'Shell', badge: 'bash' },
    curl: { name: 'cURL', badge: 'curl' },
    json: { name: 'JSON', badge: 'json' },
    yaml: { name: 'YAML', badge: 'yaml' },
    xml: { name: 'XML', badge: 'xml' },
  };

  function initCodeTabs() {
    document.querySelectorAll('.code-tabs').forEach(tabContainer => {
      // Skip if already processed
      if (tabContainer.querySelector('.code-tabs-nav')) return;

      // Find all code blocks within this tab container
      const codeBlocks = tabContainer.querySelectorAll(
        'pre code[class*="language-"], pre code[class*="lang-"]',
      );

      if (codeBlocks.length === 0) {
        // Fallback: look for any pre elements and try to detect language
        const preElements = tabContainer.querySelectorAll('pre');
        if (preElements.length > 0) {
          // Auto-detect from content or use generic labels
          preElements.forEach(pre => {
            const code = pre.querySelector('code');
            if (code && !code.className.includes('language-')) {
              // Try to auto-detect language from content
              const content = code.textContent.trim();
              let detectedLang = 'text';

              if (content.includes('<?php')) detectedLang = 'php';
              else if (
                content.includes('const ') ||
                content.includes('function ') ||
                content.includes('=>')
              )
                detectedLang = 'js';
              else if (content.includes('using System') || content.includes('public class'))
                detectedLang = 'csharp';
              else if (content.includes('def ') || content.includes('import '))
                detectedLang = 'python';
              else if (content.includes('curl ') || content.includes('wget '))
                detectedLang = 'curl';

              code.className = `language-${detectedLang}`;
            }
          });
        }
      }

      // Re-query after potential class additions
      const allCodeBlocks = tabContainer.querySelectorAll(
        'pre code[class*="language-"], pre code[class*="lang-"]',
      );

      if (allCodeBlocks.length <= 1) return; // No need for tabs with single code block

      // Create navigation
      const nav = document.createElement('div');
      nav.className = 'code-tabs-nav';

      // Wrap existing content in tab content divs
      const contents = [];
      allCodeBlocks.forEach(codeBlock => {
        const preElement = codeBlock.closest('pre');

        // Extract language from class
        const classList = Array.from(codeBlock.classList);
        const langClass = classList.find(
          cls => cls.startsWith('language-') || cls.startsWith('lang-'),
        );
        const language = langClass ? langClass.replace(/^(language-|lang-)/, '') : 'text';

        // Get display name and badge
        const langInfo = languageMap[language] || {
          name: language.charAt(0).toUpperCase() + language.slice(1),
          badge: 'default',
        };

        // Create tab button
        const button = document.createElement('button');
        button.className = 'code-tab-btn';
        button.innerHTML = `
          <span class="lang-badge ${langInfo.badge}"></span>
          ${langInfo.name}
        `;

        // Create content wrapper
        const contentDiv = document.createElement('div');
        contentDiv.className = 'code-tab-content';

        // Move the pre element into the content div
        const preClone = preElement.cloneNode(true);
        contentDiv.appendChild(preClone);
        contents.push(contentDiv);

        // Add click handler
        button.addEventListener('click', () => {
          // Remove active from all
          nav.querySelectorAll('.code-tab-btn').forEach(btn => btn.classList.remove('active'));
          contents.forEach(content => content.classList.remove('active'));

          // Add active to current
          button.classList.add('active');
          contentDiv.classList.add('active');
        });

        nav.appendChild(button);
      });

      // Clear original content and rebuild
      tabContainer.innerHTML = '';
      tabContainer.appendChild(nav);
      contents.forEach(content => tabContainer.appendChild(content));

      // Activate first tab
      if (nav.children.length > 0) {
        nav.children[0].classList.add('active');
        contents[0].classList.add('active');
      }
    });
  }

  // Try to initialize tabs multiple times to catch dynamic content
  setTimeout(initCodeTabs, 500);
  setTimeout(initCodeTabs, 1000);
  setTimeout(initCodeTabs, 2000);

  // Watch for changes
  const observer = new MutationObserver(initCodeTabs);
  const redocElement = document.querySelector('#redoc');
  if (redocElement) {
    observer.observe(redocElement, { childList: true, subtree: true });
  }
}

// Initialize ReDoc
// Always use /api/v1/docs as the base path for the OpenAPI spec
Redoc.init(
  '/api/v1/docs/openapi.yaml',
  {
    theme: {
      colors: { primary: { main: '#1f2587' } },
      logo: { maxHeight: '40px' },
      spacing: {
        sectionVertical: 0,
      },
    },
  },
  document.getElementById('redoc'),
  initReDocEnhancements,
);
